/**
 * Created by anthony on 7/7/14.
 */
/**
 * Created by anthony on 7/7/14.
 */
var standardCudFactory = angular.module('standardCudFactory', ['classy']);
standardCudFactory.factory('StandardCudFactory', function()
{
    var StandardCudFactory = function(model, id, item, ctrl, dirtyVars) {
        if (typeof model !== 'undefined')
        {
            ctrl.$.item = item;
            ctrl.$.items = model.data;
            //ctrl.$.items = angular.copy(model.get());
            this.setController(ctrl);
            this.dirtyVars = dirtyVars;
            this.updateCopy();
            this.ctrl = ctrl;
            this.model = model;
            this.id = id;
            this.ignore = false;
            this.alwaysPut = false;

        }
    };
    StandardCudFactory.prototype.setController = function(controller)
    {
        this.controller = controller;
    }
    StandardCudFactory.prototype.setIgnore = function(bool)
    {
        this.ctrl.ignore = bool;
    }
    StandardCudFactory.prototype.setAlwaysPut = function(item)
    {
        this.alwaysPut = item;
    }
    StandardCudFactory.prototype.startSaveProcess = function(scope, instance, form){
        if (form.$valid)
        {
            instance.options.factor  = .3;
            if ((typeof this.controller.$.item[this.model.primaryKey] !== 'undefined') || (this.alwaysPut)){
                return this.model.put(this.id, this.controller.$.item, instance)
            }
            else {
                return this.model.post(this.id, this.controller.$.item, instance)
            }
        }
        else
        {
            instance.stop(-1);
        }
    }
    StandardCudFactory.prototype.successSave = function (scope, instance, callback)
    {
        if (typeof this.controller.$.item.recordID === 'undefined')
            this.controller.$.item.recordID = instance.options.data.id;
        this.model.setIndex(this.controller.$.item, this.controller.index);
        this.updateCopy();
        if (typeof callback !== 'undefined')
            callback();
    }
    StandardCudFactory.prototype.startDeleteProcess = function(scope, instance){
        instance.options.factor  = .3;
        return this.model.purge(this.id, this.controller.$.item, instance);
    }
    StandardCudFactory.prototype.successDelete = function (scope, instance)
    {
        this.controller.$.items.splice(this.controller.$.index, 1);
        this.model.set(this.controller.$.items, this.controller.familyIndex);

    }

    StandardCudFactory.prototype.isNotDirty = function()
    {
        var result = true;
        for(var i = 0; i < this.dirtyVars.length; i++)
            result = result && angular.equals(this.controller.$[this.dirtyVars[i]], this.controller.$['orig' + this.dirtyVars[i]]);
        return result;
    }
    StandardCudFactory.prototype.updateCopy = function()
    {
        for(var i = 0; i < this.dirtyVars.length; i++)
            this.controller.$['orig' + this.dirtyVars[i]] = angular.copy(this.controller.$[this.dirtyVars[i]]);
    }
    StandardCudFactory.prototype.revertCopy = function()
    {
        for(var i = 0; i < this.dirtyVars.length; i++)
            this.controller.$[this.dirtyVars[i]] = angular.copy(this.controller.$['orig' + this.dirtyVars[i]]);
    }
    return StandardCudFactory;
});

standardCudFactory.service('StandardCudService', function(StandardCudFactory){
    var standardCudFactory = new StandardCudFactory();
    return standardCudFactory;
});
